import constantFactory from "@gaoding/constant-factory";

export const { SORT, SORT_LIST, SORT_MAP, SORT_ITEM_MAP } = constantFactory(
  "SORT",
  [
    {
      key: "ALL",
      label: "综合排序",
      value: "all",
      // icon: 'ic_sort'
    },
    {
      key: "TIME",
      label: "时间排序",
      value: "created_at",
      // icon: 'recent_fill'
    },
  ]
);

export const {
  SORT_BY_HOT,
  SORT_BY_HOT_LIST,
  SORT_BY_HOT_MAP,
  SORT_BY_HOT_ITEM_MAP,
} = constantFactory("SORT_BY_HOT", [
  {
    key: "seq",
    label: "拖拽排序",
    value: "seq",
  },
  {
    key: "desc",
    label: "时间降序",
    value: "desc",
  },
  {
    key: "asc",
    label: "时间升序",
    value: "asc",
  },
  {
    key: "hot",
    label: "热度排序",
    value: "weight",
  },
]);

export const {
  SORT_BY_SEARCH,
  SORT_BY_SEARCH_LIST,
  SORT_BY_SEARCH_MAP,
  SORT_BY_SEARCH_ITEM_MAP,
} = constantFactory("SORT_BY_SEARCH", [
  {
    key: "ALL",
    label: "相关性排序",
    value: null,
  },
  {
    key: "HOT",
    label: "热度排序",
    value: "weight",
  },
  {
    key: "DEST",
    label: "时间降序",
    value: "desc",
  },
  {
    key: "ASC",
    label: "时间升序",
    value: "asc",
  },
]);
